import React from 'react';
import { node, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

const OptionSelector = ({ icon, displayText }) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      pr: 2,
      width: '100%',
    }}
  >
    <Typography
      sx={{
        mt: '2px',
      }}
      variant="body1"
    >
      {displayText}
    </Typography>
    {icon && icon}
  </Box>
);

OptionSelector.propTypes = {
  displayText: string.isRequired,
  icon: node,
};

OptionSelector.defaultProps = {
  icon: null,
};

export default OptionSelector;
